import { useQuery } from '@tanstack/react-query';
import type { HealthResponse } from '@shared/api-types';
import { api } from '../lib/api';
import type { ApiClientError } from '../lib/api';
import { queryKeys } from '../lib/query';
import { Badge } from './ui/badge';

/**
 * Pasek "TRYB FIXTURE" w powloce aplikacji.
 *
 * Odpowiedz na realne zdziwienie osoby testujacej: przy `OPENROUTER_MODE=fixture`
 * wygenerowany "packshot" to kolorowy kwadrat PNG 8x8 i wyglada jak awaria
 * pipeline'u. Tryb bierzemy z `GET /api/health` (pole `modes`), bo to jedyne
 * miejsce, gdzie przegladarka widzi konfiguracje Workera.
 *
 * Ma byc dyskretny: jedna linia, bez `role="alert"` — to stan srodowiska,
 * nie blad. Ten sam klucz zapytania co `HomePage`, wiec nie ma drugiego
 * zapytania sieciowego.
 */
export function ProviderModeBanner() {
  const health = useQuery<HealthResponse, ApiClientError>({
    queryKey: queryKeys.health,
    queryFn: () => api.health(),
    staleTime: 60_000,
  });

  const modes = health.data?.modes;
  if (modes === undefined || modes.openrouterMode !== 'fixture') return null;

  return (
    <div
      role="status"
      data-testid="provider-mode-banner"
      className="border-b border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-200"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-2 px-3 py-1.5 text-xs">
        <Badge tone="warning">TRYB FIXTURE</Badge>
        <span>
          Obrazy sa zastepcze (PNG 8x8), nic nie kosztuje.
          {modes.falMode === 'fixture' ? ' Upscale tez jest atrapa.' : null}
        </span>
        <span className="hidden opacity-70 sm:inline">
          Prawdziwe modele: OPENROUTER_MODE=live w .dev.vars — to juz kosztuje.
        </span>
      </div>
    </div>
  );
}

export default ProviderModeBanner;
